import utils from './utils'

const canvas = document.querySelector('canvas')
const c = canvas.getContext('2d')
document.title = 'gravity'
canvas.width = innerWidth
canvas.height = innerHeight

const mouse = {
    x: innerWidth / 2,
    y: innerHeight / 2
}

const mouseClick = {
    x: innerWidth / 2,
    y: innerHeight / 2
}

const colors = ['#2185C5', '#7ECEFD', '#FFF6E5', '#FF7F66']
let gravity = 1
let friction = 0.96
// Event Listeners
addEventListener('mousemove', event => {
    mouse.x = event.clientX
    mouse.y = event.clientY
})

addEventListener('click', event => {
    mouseClick.x = event.clientX
    mouseClick.y = event.clientY
})

addEventListener('resize', () => {
    canvas.width = innerWidth
    canvas.height = innerHeight

    init()
})

addEventListener('click', () => {
    init()
})



// Objects
function Ball(x, y,dx,dy,radius, color) {
    this.x = x
    this.y = y
    this.radius = radius
    this.color = color
    this.dx = dx
    this.dy = dy
}

Ball.prototype.draw = function() {
    c.beginPath()
    c.arc(this.x, this.y, this.radius, 0, Math.PI * 2, false)
    c.fillStyle = this.color
    c.fill()
    c.closePath()
}

Ball.prototype.update = function() {
    if(this.y + this.radius > canvas.height){
        this.dy=-this.dy * friction;
    }else{
        this.dy += gravity;
    }

    if(this.x+this.radius + this.dx > canvas.width || this.x -this.radius - this.dx < 0){
        this.dx = -this.dx
    }

    this.x+=this.dx
    this.y+=this.dy
    this.draw()
}

// Implementation
let balls
function init() {
    balls = []
    for (let i = 0; i < 400; i++) {
        var radius = utils.randomIntFromRange(4,20) ;
        var x = utils.randomIntFromRange(radius,(canvas.width -radius));
        var y = utils.randomIntFromRange(0,(canvas.height -radius));
        var dx = utils.randomIntFromRange(-2,2)
        var dy = utils.randomIntFromRange(-2,2)
        var color = utils.randomColor(colors);
        balls[i] = new Ball(x,y,dx,dy,radius,color)
    }
}
// Animation Loop
function animate() {
    requestAnimationFrame(animate)
    c.clearRect(0, 0, canvas.width, canvas.height)
    balls.forEach(ball => {
        ball.update();
        
    });
}

init()
animate()
